module.exports = __webpack_public_path__ + "media/images/850/weight_loss_bed-e164c76d112635d17aed67747f53cabe.webp";